// Build-time version constants injected by vite.config.ts
export const APP_VERSION: string = __APP_VERSION__;
export const GIT_HASH: string    = __GIT_HASH__;

/** Human-readable string, e.g. "v0.1.0 · ba65dff" */
export const VERSION_STRING = `v${APP_VERSION} · ${GIT_HASH}`;
